import { useGlobal } from '@/utils/useGlobal';
import css from './index.module.scss';

export default function N() {
    const { useLang } = useGlobal();
    const { t } = useLang('productriver2');
    return (
        <section className={`river2_details_N ${css.N_14}`}>
            <div className="innerBox">
                <p className="line"></p>
                <p className="note">{t('river2.details.sec14_note')}</p>
            </div>
        </section>
    );
}
